import type { IconProps } from '../types/IconProps.ts';
export const SkipBack: IconProps = {
    name: 'SkipBack',
    children: [
        `<path d="M3 4v16M7.77 13.38a1.62 1.62 0 0 1 0-2.76L18.8 4.2c.99-.58 2.2.18 2.2 1.38v12.84c0 1.2-1.21 1.96-2.2 1.38z" />`,
    ]
};